import { render, staticRenderFns } from "./V4IntroModal.vue?vue&type=template&id=639a0b9c&scoped=true&"
import script from "./V4IntroModal.vue?vue&type=script&lang=ts&"
export * from "./V4IntroModal.vue?vue&type=script&lang=ts&"
import style0 from "./V4IntroModal.vue?vue&type=style&index=0&id=639a0b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639a0b9c",
  null
  
)

export default component.exports